import numeral from 'numeral';

import loadConstants from 'utils/loads/constants';

const getLengthUnitsDependingOnValue = (value) =>
  value >= loadConstants.MAX_UNITS_TO_CONVERT_CM_TO_M
    ? loadConstants.LENGTH_UNITS.METRES
    : loadConstants.LENGTH_UNITS.CENTIMETRES;

const getLengthFormatedInUnits = (value, unit) =>
  unit === loadConstants.LENGTH_UNITS.CENTIMETRES
    ? value
    : numeral(value / 100).format('0[.]0');

const getPalletDimensionsFormatted = ({
  length,
  width,
  t,
  format = 'verbose',
}) => {
  const lengthUnit = getLengthUnitsDependingOnValue(length);
  const widthUnit = getLengthUnitsDependingOnValue(width);

  const sameUnits = lengthUnit === widthUnit;
  const formatterByType = {
    verbose: 'loads:pallet_dimensions.verbose',
    short: sameUnits
      ? 'loads:pallet_dimensions.short.same_units'
      : 'loads:pallet_dimensions.short.different_units',
  };

  return t(formatterByType[format], {
    length: getLengthFormatedInUnits(length, lengthUnit),
    lengthUnit,
    width: getLengthFormatedInUnits(width, widthUnit),
    widthUnit,
  });
};

export default getPalletDimensionsFormatted;
